const tenantDataToOptions = (tenantData) => {
  return tenantData.map((tenant) => ({
    value: tenant?.tenantId,
    label: tenant?.tenantId,
  }));
};

export default tenantDataToOptions;
